export const toHomepage = () => "/homepage";
export const toArtPage = () => "/art";